import { Component, OnInit, Input, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { Subject } from 'rxjs/Subject';
import { Observable } from 'rxjs/Observable';
import { DomainService } from 'app/core/services/domain.service';
import { ProfileService } from 'app/core/components/profile/profile.service';
import { LicenseService } from 'app/core/services/license.service';
import { LoadingPage } from 'app/shared/components/loading/loading.page.component';
import { CommBoxConfig } from 'app/core/components/workflow-new/common/communication-box/communication-box.component';
import { CatalogProductsService } from 'app/core/services/catalog-products.service';
import { Router, ActivatedRoute } from '@angular/router';
import { SmartModalService, ModalSize } from 'app/core/services/smart-modal.service';
import { SimpleInfoComponent } from 'app/shared/components/modal/simple-info.component';
import { SimpleAlertComponent } from 'app/shared/components/modal/simple-alert.component';

@Component({
  selector: 'itpx-course-stack-presentation',
  templateUrl: './course-stack-presentation.component.html',
  styleUrls: ['../../common/style.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CourseStackPresentationComponent extends LoadingPage implements OnInit {
  private backgroundUrl$: Observable<string>;
  // private backgroundUrl: string = 'https://itpx-branded-portal-dev.s3.amazonaws.com/course-background.png';
  private domain: any;
  private username$ = new Subject<any>();
  private licenses$: Observable<any>;
  private catalogProducts$: Observable<any>;
  private tab: string;
  private showAllCourses: boolean;
  private catalogProductsLength: number;
  private myCoursesLength: number;
  private currentPage = 1;
  private readonly emptyConfig: CommBoxConfig = {
    message: 'branded.portal.courses.assignment.empty.message',
    actions: [{ title: 'Redeem Voucher', style: 'btn btn-light', link: ['/app/redeem'] }],
    domain: this.domainService.getDomain(),
    level: 'info'
  }

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private domainService: DomainService,
    private profileService: ProfileService,
    private licenseService: LicenseService,
    private catalogProductsService: CatalogProductsService,
    private detector: ChangeDetectorRef,
    private modalService: SmartModalService
  ) {
    super();
  }

  ngOnInit() {

    this.backgroundUrl$ = this.domainService.getBanner();
    this.domain = this.domainService.getDomain();
    // console.log(this.domain);
    if (this.domain.grantAccess) {
      this.showAllCourses = true;
      if (this.domain.landingTab === 'CATALOG') {
        this.tab = 'allCourses';
        this.catalogProducts$ = this.catalogProductsService.getCatalogProductSkus().map(c => { this.catalogProductsLength = c.flags.size; return c.data.map(d => d.productSku) })
          .switchMap(v => this.catalogProductsService.getCatalogProducts({ skus: v })).map(res => res.data).do(_ => this.ready());
      }
      else {
        this.tab = 'myCourses';
        this.licenses$ = this.licenseService.getUpdatedLicenses().map(res => { this.myCoursesLength = res.flags.size; return res.data }).do(_ => this.ready());
      }
      // this.domain.landingTab === 'CATALOG' ? this.tab = 'allCourses' : this.tab = 'myCourses';
      // this.catalogProducts$ = this.catalogProductsService.getCatalogProductSkus().map(c => { this.catalogProductsLength = c.flags.size; return c.data.map(d => d.productSku) })
      //   .switchMap(v => this.catalogProductsService.getCatalogProducts({ skus: v })).map(res => res.data).do(_ => this.ready());
      // this.catalogProducts$.bindToLifecycle(this).subscribe(_ => {this.ready();this.detector.detectChanges();})
    }
    else {
      this.tab = 'myCourses';
      this.showAllCourses = false;
      this.licenses$ = this.licenseService.getUpdatedLicenses().map(res => { this.myCoursesLength = res.flags.size; return res.data }).do(_ => this.ready());
      // this.ready();
    }

    this.profileService.getProfile().map(resp => resp.data)
      .subscribe(user => this.username$.next({ username: `${user.firstName} ${user.lastName}`, domain: this.domain }));
    // this.licenses$ = this.licenseService.getUpdatedLicenses().map(res => res.data);
  }

  trackByFn(index, item) {
    return index; // or item.id
  }

  onTabClicked(tab: string) {
    this.tab = tab;
    this.loading();
    this.currentPage = 1;
    if (tab === 'allCourses') {
      this.catalogProducts$ = this.catalogProductsService.getCatalogProductSkus().map(c => { this.catalogProductsLength = c.flags.size; return c.data.map(d => d.productSku) })
        .switchMap(v => this.catalogProductsService.getCatalogProducts({ skus: v })).map(res => res.data).do(_ => this.ready());
    }
    else {
      this.licenses$ = this.licenseService.getUpdatedLicenses().map(res => { this.myCoursesLength = res.flags.size; return res.data }).do(_ => this.ready());
    }
  }

  onStateChange(event: string) {
    if (event === 'loading') {
      this.loading();
    }
    if (event === 'ready') {
      this.ready(); // below can be used for re-fetching the catalog prodicts on error.
      // this.catalogProducts$ = this.catalogProductsService.getCatalogProductSkus().map(c => { this.catalogProductsLength = c.flags.size; return c.data.map(d => d.productSku) })
      //   .switchMap(v => this.catalogProductsService.getCatalogProducts({ skus: v })).map(res => res.data).do(_ => this.ready());
    }
    this.detector.detectChanges();
  }
  onPageChanged(e) {
    // console.log(e);
    this.loading();
    this.currentPage = e;
    if (this.tab === 'allCourses') {
      this.catalogProducts$ = this.catalogProductsService.getCatalogProductSkus({ page: e, limit: 10, filter: '' }).map(c => { this.catalogProductsLength = c.flags.size; return c.data.map(d => d.productSku) })
        .switchMap(v => this.catalogProductsService.getCatalogProducts({ skus: v })).map(res => res.data).do(_ => this.ready());
    }
    else {
      this.licenses$ = this.licenseService.getUpdatedLicenses({ page: e, limit: 10, filter: '' }).map(res => { this.myCoursesLength = res.flags.size; return res.data }).do(_ => this.ready());
    }
    // this.catalogProducts$.bindToLifecycle(this).subscribe(_ => this.ready())
    // this.ready();
  }
  onClickDetails() {
    this.modalService.open(SimpleAlertComponent, {
      text: this.domain.details,
      btn:'btn-edcast-neutral',
      btnPosition:'center',
      btnYesText: 'Close', 
    }, this.domain.buyerName, ModalSize.Md,null,this.domain.logo)
      .neverError()
      .subscribe();
  }
}


// WEBPACK FOOTER //
// ./src/app/core/components/workflow-new/course/course-stack-presentation/course-stack-presentation.component.ts